module.exports = __webpack_public_path__ + "static/img/male-5.fc879f99.png";